import React from 'react';
import { Outlet, NavLink, useLocation } from 'react-router-dom';
import { AppLayout, Sidebar } from '../ds';
import { useAuth } from '../../context/AuthContext';

const IconAds = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="3" y="3" width="14" height="14" rx="2"/><path d="M7 7h6M7 10h4"/>
  </svg>
);

export default function Layout() {
  const { logout } = useAuth();
  const location = useLocation();
  const companyName = localStorage.getItem('portal_company_name') || 'Portal';

  const handleLogout = async () => {
    try {
      await logout();
      localStorage.removeItem('portal_company_id');
      localStorage.removeItem('portal_company_name');
    } catch (e) { /* ignore */ }
  };

  const pageTitle = location.pathname.startsWith('/ads/create') ? 'Create Ad'
    : location.pathname.startsWith('/ads') ? 'Ads'
    : '';

  return (
    <AppLayout
      sidebar={
        <Sidebar logo="VMFIVE" subtitle={companyName} footer={
          <button
            onClick={handleLogout}
            style={{
              width: '100%', padding: '6px 16px', background: 'none',
              border: '1px solid rgba(255,255,255,0.2)', color: '#fff',
              borderRadius: 4, fontSize: 13, cursor: 'pointer', fontFamily: 'inherit',
            }}
          >
            Logout
          </button>
        }>
          <Sidebar.Group title="Ads">
            <NavLink to="/ads" end style={{ textDecoration: 'none' }}>
              {({ isActive }) => <Sidebar.Item icon={<IconAds />} label="All Ads" active={isActive} />}
            </NavLink>
          </Sidebar.Group>
        </Sidebar>
      }
      header={<h2 style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>{pageTitle}</h2>}
    >
      <Outlet />
    </AppLayout>
  );
}
